<ng-container *transloco="let t">
    <ng-container
        *ngIf="{
            required: required$ | async,
            optionList: options$ | async,
            disabled: disabled.$ | async,
            values: values.$ | async,
            selectedValues: selectedValues$ | async,
        } as data"
    >
        <div
            *ngIf="ngControl.control; let control"
            class="bazis-control"
            [ngClass]="{
                'bazis-control--invalid': ngControl.control.invalid,
                'bazis-control--disabled': data.disabled,
                'bazis-control--dirty': ngControl.control.dirty,
                'bazis-control--empty': emptyValues.indexOf(ngControl.control.value) > -1,
            }"
        >
            <bazis-label
                [class.bh-font-normal]="!hasLabelMajor"
                [title]="title || t(titleKey, titleParams)"
                [required]="data.required"
            >
                <bazis-interrogation
                    *ngIf="tooltipKey"
                    [slot]="tooltipSettings?.targetSide"
                    iconSize="compact"
                    [tooltipText]="t(tooltipKey, tooltipParams)"
                    [tooltipOffset]="[-8, 4]"
                    [tooltipEventType]="tooltipSettings?.eventType || 'hover'"
                    [tooltipPlacement]="tooltipSettings?.placement || 'top-start'"
                    [icon]="icons.interrogation"
                    [type]="interrogationType"
                ></bazis-interrogation>
            </bazis-label>

            <bazis-segment
                [segmentList]="data.optionList"
                [segmentTemplate]="segmentTemplate"
                [selectedSegment]="data.selectedValues[0]?.id"
                (selectedSegmentChange)="toggleValue($event)"
                [color]="ngControl.control.invalid ? 'danger' : ''"
            ></bazis-segment>

            <ng-template
                #segmentTemplate
                let-option="segment"
            >
                <span>
                    <ng-container *ngIf="option.$snapshot.name">
                        {{ option.$snapshot.name }}
                    </ng-container>
                    <ng-container *ngIf="option.$snapshot.nameKey">
                        {{ t(option.$snapshot.nameKey) }}
                    </ng-container>

                    <bazis-icon
                        *ngIf="option.$snapshot.tooltipKey || option.$snapshot.tooltip"
                        slot="end"
                        [name]="icons.interrogation"
                    ></bazis-icon>
                </span>
            </ng-template>

            <div class="bazis-control__error">
                <bazis-form-error [formControl]="ngControl.control"></bazis-form-error>
            </div>
            <div
                *ngIf="noteKey"
                class="bazis-control__note"
            >
                {{ t(noteKey) }}
            </div>
        </div>
    </ng-container>
</ng-container>
